import {
  AfterViewInit,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import { tSite } from '@models/Tables/tSite';

@Component({
  selector: 'app-mandatory-terms',
  templateUrl: './mandatory-terms.component.html',
  styleUrls: ['./mandatory-terms.component.scss'],
  standalone: false,
})
export class MandatoryTermsComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() site: tSite;
  @Input() validationGroup;

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {}

  onRequiredCheck = (e: any) => {
    if (e.value) {
      return true;
    }
    return false;
  };
}
